import {Component} from 'react'
import {connect} from 'react-redux'

import StrategyFreelanceContainer from './StrategyFreelanceContainer.jsx'
import EditFreelance from './Components/EditFreelance/EditFreelance.jsx'
import mustBeLogged from '../../components/Must/MustBeLogged.jsx'
import conf from '../../../shared/conf.js'
import mustHaveAcceptedCGU from '../../components/Must/MustHaveAcceptedCGU.jsx'
import withCurrentUniverse, {CURRENT_USER_PRIORITY} from '../../HOC/withCurrentUniverse.jsx'

class EditFreelanceContainer extends Component {
  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return nextProps.endLoadingCurrentUser
  }

  render() {
    const {currentUser, currentFreelance, endLoadingCurrentUser} = this.props

    if (!endLoadingCurrentUser) {
      return null
    }

    return (
      <StrategyFreelanceContainer
        currentUser={currentUser}
        loading={!endLoadingCurrentUser}
        profile={{user: currentUser, freelance: currentFreelance}}
        route={this.props.route}
        view={EditFreelance}
      />
    )
  }
}

export default connect(
  (state) => ({
    endLoadingCurrentUser: state.currentUser.endLoading,
  }),
)(
  withCurrentUniverse(
    mustBeLogged(
      mustHaveAcceptedCGU(EditFreelanceContainer),
      conf.accountTypes.freelance
    ),
    CURRENT_USER_PRIORITY
  )
)